import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Benign browser warning (fires during route changes); keep it out of the dev error overlay.
window.addEventListener("error", (e) => {
    if (e.message && e.message.includes("ResizeObserver loop")) e.stopImmediatePropagation();
});

// If our post-build prerender script (scripts/prerender.js) already
// wrote a fully-rendered React tree into #root for this route, hydrate
// on top of it so we don't wipe out server-visible content and don't
// re-run the initial render. Otherwise (dev mode, first paint on a
// route the prerender skipped) do a fresh client render.
const rootEl = document.getElementById("root");
if (rootEl.hasChildNodes()) {
    ReactDOM.hydrateRoot(
        rootEl,
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
} else {
    ReactDOM.createRoot(rootEl).render(
        <React.StrictMode>
            <App />
        </React.StrictMode>,
    );
}
